import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParticipatingView = ({ route: { name: routeName } }) => {
  const PARTICIPATING_ROUTES = [
    'conversation_participating',
    'conversation_through_participating',
  ];
  return PARTICIPATING_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

// Keep in sync with ChatList conversationListPagination / CONVERSATION_RESULTS_PER_PAGE.
const CONVERSATION_LIST_PAGE_SIZE = 25;

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  // SiteUp perf: list endpoint may defer mine/unassigned/all COUNTs
  // (meta.counts_deferred). Never stamp badges to 0 — refresh via /meta so
  // notifications and the list stay live; only badge numbers arrive a beat later.
  if (metaData && metaData.counts_deferred) {
    context.dispatch(
      'conversationStats/getNow',
      requestPayload,
      { root: true }
    );
  } else {
    context.dispatch('conversationStats/set', metaData);
  }
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  // Empty page OR short final page → end. Short-page matters for Kanban when
  // membership < page size: without it, IntersectionObserver kept requesting
  // the next page forever when the page key was missing/NaN (always page 1).
  const received = Array.isArray(conversationList)
    ? conversationList.length
    : 0;
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: received === 0 || received < CONVERSATION_LIST_PAGE_SIZE,
  });
};
